// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__jo88Q","title":"notFound_title__9r8Dp","text":"notFound_text__vq62F","button":"notFound_button__nndDB","linkIcon":"notFound_linkIcon__ePXp9"};